<template>
  <div class="container">
    <record-cell v-for="(item, index) in recordList" :key="index" :item="item" @clickItem="onClickItem"></record-cell>
    <van-empty v-if="!loading && recordList.length === 0" description="暂无记录" />
  </div>
</template>

<script>
import API from '@/api'
import { mapState } from 'vuex';
import RecordCell from '@/components/wxrecord/RecordCell.vue';
export default {
  components: {
    RecordCell
  },
  computed: {
    ...mapState(['user'])
  },
  data() {
    return {
      recordList: [],
      loading: false
    }
  },
  created() {

  },
  mounted() {
    this.getRecordList()
  },
  methods: {
    async getRecordList() {
      this.loading = true
      try {
        const data = await API.sleepSelfAssessment({ uid: this.user.user.uid, pageNum: 1, pageSize: 10000 })
        this.recordList = data?.list || []
      } catch (error) {
        this.$toast(error)
      } finally { 
        this.loading = false
      }
    },
    onClickItem(item) {
      this.$router.push({name: 'RecordDetail', query: { id: item.id }})
    }
  },
}
</script>
<style scoped lang='scss'>
.container {
  width: 100%;
  height: 100%;
  background: #F7F7F7;
  overflow: auto;
}
</style>